import { Enumify } from "enumify";

class AdApplication extends Enumify {
  static insertMedia = new AdApplication({
    name: "매체삽입용",
    status: 1,
  });
  static education = new AdApplication({
    name: "교육용",
    status: 2,
  });
  static storeReference = new AdApplication({
    name: "자료보관용",
    status: 3,
  });
  static etc = new AdApplication({
    name: "기타",
    status: 4,
  });
  static _ = this.closeEnum();

  constructor(props) {
    super();
    Object.defineProperties(this, Object.getOwnPropertyDescriptors(props));
  }
}

export default AdApplication;
